import api from "./axios";
import { DraftList } from "../types/invoice";

export const previewInvoices = async (draft: DraftList) => {
  console.log("[DEBUG][API] /invoices/preview payload =", { invoices: draft });
  const res = await api.post("/invoices/preview", { invoices: draft });
  console.log("[DEBUG][API] /invoices/preview response =", res.data);
  // pamiętaj: gdzieś dalej zapisujesz to do localStorage.preview_result
  return res.data;
};

export const saveDraftFromBuilder = async (body: {
  fakturownia_client_id: number;
  name: string;
  department_name: "semtop" | "adtarget";  // NOWE
  payload: any;
}) => {
  const res = await api.post("/invoice_drafts/templates/save-from-builder", body);
  return res.data as DraftTemplateOut;
};


// ===== Drafts API (B-Lite) =====
export type AdsAccountInfo = {
  source_type: string;
  client_id: string;
  display_name: string;
};

export type DraftTemplateOut = {
  id: number;
  fakturownia_client_id: number;
  fakturownia_client_name?: string;
  name: string;
  date_policy: "rolling_30" | "previous_month" | string;
  anchor_start_date?: string | null;
  department_name: "semtop" | "adtarget";  // NOWE
  allegro_client_ids: string[];  // Deprecated - backward compatibility
  allegro_nicknames?: string[];  // Deprecated
  ads_accounts?: AdsAccountInfo[];  // New unified field
  active: boolean;
  has_percent: boolean;
  payload?: any;
};

export const listDrafts = async (
  fakturownia_client_id?: number,
  q?: string,
  account?: string,  // Changed from allegro to account (searches both Allegro and Google Ads)
  department_name?: string,  // NOWE - filter by company
  limit?: number,
  offset?: number
) => {
  const res = await api.get("/invoice_drafts/templates", {
    params: {
      fakturownia_client_id,
      q,
      account,
      department_name,  // NOWE
      limit,
      offset,
    },
  });
  return res.data as { items: DraftTemplateOut[]; total: number; limit: number; offset: number };
};

export const previewDraft = async (id: number, month_key?: string) => {
  const res = await api.post(`/invoice_drafts/templates/${id}/preview`, month_key ? { month_key } : {});
  // backend zwraca pojedynczą "fakturę" w kształcie zbliżonym do /invoices/preview
  return res.data as {
    client_id: number;
    type: "proforma" | "vat" | string;
    department_name: "semtop" | "adtarget";  // NOWE
    period: { start: string; end: string };
    positions: Array<{
      name: string; amount_netto?: number; vat: number; amount_brutto?: number;
      description?: string; type: "base" | "percent" | "adjustment";
      nickname?: string; customer_id?: string;  // Account tracking
    }>;
    ads_accounts?: Array<{
      source_type: string;
      client_id: string;
      display_name: string;
    }>;
  };
};

export const deleteDraft = async (id: number) => {
  await api.delete(`/invoice_drafts/templates/${id}`);
};

export const getDraft = async (id: number) => {
  const res = await api.get(`/invoice_drafts/templates/${id}`);
  return res.data as DraftTemplateOut;
};

export const updateDraft = async (
  id: number,
  body: {
    name?: string;
    date_policy?: "rolling_30" | "previous_month";
    anchor_start_date?: string | null;
    payload?: any;
    active?: boolean;
  }
) => {
  const res = await api.put(`/invoice_drafts/templates/${id}`, body);
  return res.data as DraftTemplateOut;
};


// ===== Manual Ads Account Management =====
export type DraftAccountWithBitrix = {
  source_type: string;
  client_id: string;
  display_name: string;
  bitrix_deal: {
    id: number;
    title: string;
    stage_name: string;
    budget: number | null;
    budget_note: string | null;
  } | null;
  is_manual_assignment: boolean;
  is_from_position: boolean;  // True = from position, False = manually added (deletable)
};

/**
 * Add an Ads account to a draft (for informational purposes).
 * Also triggers Bitrix auto-matching.
 */
export const addAccountToDraft = async (
  templateId: number,
  sourceType: "allegro" | "google_ads",
  clientId: string
) => {
  const res = await api.post(`/invoice_drafts/templates/${templateId}/accounts`, {
    source_type: sourceType,
    client_id: clientId,
  });
  return res.data as {
    source_type: string;
    client_id: string;
    display_name: string;
    bitrix_deal: DraftAccountWithBitrix["bitrix_deal"];
    message: string;
  };
};

/**
 * Remove an Ads account from a draft.
 */
export const removeAccountFromDraft = async (
  templateId: number,
  sourceType: string,
  clientId: string
) => {
  await api.delete(`/invoice_drafts/templates/${templateId}/accounts/${sourceType}/${clientId}`);
};

/**
 * List all Ads accounts in a draft with Bitrix deal info.
 */
export const listDraftAccounts = async (templateId: number) => {
  const res = await api.get(`/invoice_drafts/templates/${templateId}/accounts`);
  return res.data as DraftAccountWithBitrix[];
};